import { ExternalProvider } from 'vince-core/types/auth';
import { microsoftAdapter } from 'vince-core/composables/auth-adapters/microsoft';


export const EXTERNAL_PROVIDERS = {
    [ExternalProvider.MICROSOFT]: microsoftAdapter
};
